import { observable, action, runInAction, computed, makeObservable } from "mobx";
import { CoreStore, handleStoreState } from "Stores/RESTStore/CoreStore";
import { API_URL } from "General/APIEndpoints";
import { projectsDataStore } from "Stores";
import { API } from "General/API";
import { dayjs } from "Config/dayjs";

export class MetadataAssistantStore extends CoreStore {
  data: API_Metadata[] = [];
  missingMetadata: API_UploadMetadata[] = [];
  isVisible = false;
  files: API_UploadFile[] = [];

  constructor() {
    super();

    makeObservable(this, {
      data: observable,
      missingMetadata: observable,
      isVisible: observable,
      files: observable,
      clear: action.bound,
      setMissingMetadata: action.bound,
      toggleModalVisible: action.bound,
      setActiveFiles: action.bound,
      getMissingMetadataValueById: action.bound,
      missingMetadataIds: computed,
      filteredMetadata: computed,
      initialMetadataValues: computed,
      fetch: action.bound,
    });
  }

  url() {
    return API_URL.METADATA.getDefinitionsFull(projectsDataStore.projectId);
  }

  clear() {
    this.data = [];
    this.missingMetadata = [];
    this.files = [];
  }

  @handleStoreState()
  async fetch() {
    try {
      const response: API_Metadata[] = await API.getData(this.url());
      runInAction(() => {
        this.data = response;
      });
    } catch (error) {
      throw error;
    }
  }

  setMissingMetadata(data: API_UploadMetadata[]) {
    this.missingMetadata = data;
  }

  toggleModalVisible() {
    this.isVisible = !this.isVisible;
    if (!this.isVisible) {
      this.missingMetadata = [];
      this.files = [];
    }
  }

  setActiveFiles(files: API_UploadFile[]) {
    this.files = files.slice();
  }

  getMissingMetadataValueById(id: number) {
    return this.missingMetadata.find((md) => md.id === id).value;
  }

  get missingMetadataIds() {
    return Array.from(new Set(this.missingMetadata.map((md) => md.id)));
  }

  get filteredMetadata() {
    return this.missingMetadataIds.map((msMdId) => ({
      ...this.data.find((md) => md.definitionId === msMdId),
      defaultValue: this.getMissingMetadataValueById(msMdId),
    }));
  }

  get initialMetadataValues() {
    const initialData = {};
    const pattern = (name: string, id: number) => `${name}-DEFID${id}`;

    this.filteredMetadata.forEach(({ key, definitionId, defaultValue, format }) => {
      if (format.toLowerCase() === "date") {
        const date = dayjs(defaultValue, "DD.MM.YYYY");

        initialData[pattern(key, definitionId)] = date.isValid() ? date : null;
      } else if (defaultValue) {
        initialData[pattern(key, definitionId)] = defaultValue;
      }
    });

    return initialData;
  }
}

export const metadataAssistantStore = new MetadataAssistantStore();
